import React from "react";

import { TypeType } from "../../../../models/ChartCollectionData";

import "./styles.scss";

export interface IChartButtonIconProps {
  type: TypeType;
}

export const ChartButtonIcon: React.FunctionComponent<IChartButtonIconProps> = (
  props
) => {
  const { type } = props;

  switch (type) {
    case "line":
      return <i className="icons icon-line-chart chart-button-icon">&nbsp;</i>;
    case "bar":
      return <i className="icons icon-bar-chart chart-button-icon">&nbsp;</i>;
    case "pie":
      return (
        <i className="icons icon-circle-chart chart-button-icon">&nbsp;</i>
      );
    case "table":
      return <i className="icons icon-grid-chart chart-button-icon">&nbsp;</i>;
  }
};
